<div class="container">
    <div class="row">
        <ng-container *ngFor="let col of data.richTextColumns">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngIf="col.richText as richText">
                <div
                    class="kk-rte rte"
                    [ngClass]="{ 'kk-rte_a-reverse-hover': data.reverseLinkHoverEffect }"
                    [innerHTML]="col.richText | safe: 'html'"
                    appInterceptLinks
                ></div>
            </div>
        </ng-container>
    </div>
</div>
